import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

import {ProductsArticle} from './products-article';

@Injectable()
export class ImportItemsService {
    private api_url_get_warehouses = './api/switch_site/server.php?cmd=GET_WAREHOUSE_WITHOUT';
    private api_url_get_items_by_warehouse = './api/server.php?cmd=GET_ITEMS_BY_WAREHOUSE';
    private api_url_save_item_in_an_other_warehouse = './api/server.php?cmd=SAVE_ITEM_IN_AN_OTHER_WAREHOUSE';

    constructor(private http: Http) {}

    getItemsByWarehouse(warehouse: string): Promise<Object> {
        return this.http.get(this.api_url_get_items_by_warehouse
            + '&warehouse=' + warehouse
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getWarehouses(): Promise<Object> {
        return this.http.get(this.api_url_get_warehouses)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    importItem(internal_code: any, warehouse: any, save_suppliers: boolean, save_categories: boolean) {
        return this.http.get(this.api_url_save_item_in_an_other_warehouse
            + '&internal_codes=' + internal_code
            + '&warehouse=' + warehouse
            + '&save_suppliers=' + save_suppliers
            + '&save_categories=' + save_categories
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/import-items.service.ts